/**
 * BOXの内側のスクロールエリアに適用する
 * vuescroll設定オプション
 */
export const innerVueScrollOption = {
  vuescroll: {
    detectResize: true
  },
  bar: {
    background: '#B7A142',
    opacity: 0.5
  }
};
